
import {
    getClassifyList,
    createBookGood,
    updateBookGood,
    deleteGood,
    findBookGood,
    listingDelisting,
    getBookGoodById
} from '@/zsm-api-new/dyCloud/book/redBook.js'
const state = {

}

const mutations = {

}

const actions = {


    /**
     * 获取末级分类
     * @returns 
     */
    getClassifyList({ commit }) {
        return new Promise((resolve, reject) => {
            getClassifyList().then(response => {
                resolve(response.data || [])
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 获取商品详情
     * @param {String} id  商品Id
     * @returns 
     */
    getBookGoodById({ commit }, id) {
        return new Promise((resolve, reject) => {
            getBookGoodById(id).then(response => {
                resolve(response.data || '')
            }).catch(error => {
                reject(error)
            })
        })
    },
    /**
     * 修改商品上下架
     * @param {String} id 商品Id
     * @param {String} shelfFlag 上下架标记
     * @returns 
     */
    listingDelisting({ commit }, data) {
        return new Promise((resolve, reject) => {
            listingDelisting(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 创建商品 
     * @param id 商品ID
     * @param loginCode 讲师账号
     * @param name 商品名称
     * @param price 价格
     * @param categoryId 类目ID
     * @param categoryName 类目名称
     * @param shippingTemplateId 物流模板Id
     * @param shippingTemplateName 商品主图
     * @param cover 物流模板Id
     * @param coverList 商品主图
     * @param content 商品主图
     * @param deliveryMode 物流模式,0：普通，1：支持无物流发货
     * @param freerReturn 是否支持7天无理由,1：支持，2：不支持
     * @param stockNum 库存
     * @returns 
     */
    createBookGood({ commit }, data) {
        return new Promise((resolve, reject) => {
            createBookGood(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    /**
  * 修改商品 
  * @extends createBookGood
  * @returns 
  */
    updateBookGood({ commit }, data) {
        return new Promise((resolve, reject) => {
            updateBookGood(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    /**
     * 删除商品
     * @param id 商品Id
     * @returns 
     */
    deleteGood({ commit }, id) {
        return new Promise((resolve, reject) => {
            deleteGood(id).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    /**
     * 获取商品
     * @extends createBookGood
     * @param {Object} params 参数(参加创建的参数)
     * @returns 
     */
    findBookGood({ commit }, params) {
        delete params.pageAllCount;
        for (let i in params) {
            if (params[i] == '') {
                delete params[i];
            }
        }
        return new Promise((resolve, reject) => {
            findBookGood(params).then(response => {
                // 没有数据默认给空数组
                if (response.result == 'false') {
                    response.data = {
                        records: [],
                        total: 0
                    }
                }
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
